import { render, staticRenderFns } from "./SessionForm.vue?vue&type=template&id=b89c7b6a&"
import script from "./SessionForm.vue?vue&type=script&lang=js&"
export * from "./SessionForm.vue?vue&type=script&lang=js&"
import style0 from "./SessionForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports